import { render, staticRenderFns } from "./cartView.vue?vue&type=template&id=22e2d62c&"
import script from "./cartView.vue?vue&type=script&lang=js&"
export * from "./cartView.vue?vue&type=script&lang=js&"
import style0 from "./cartView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports